import { TimeScaleReturn } from '../create/time-scale/timeScale';

const scrollWheelSpeedAdjustment = (event: WheelEvent): number => {
  switch (event.deltaMode) {
    case event.DOM_DELTA_PAGE:
      // one screen at time scroll mode
      return 120;
    case event.DOM_DELTA_LINE:
      // one line at time scroll mode
      return 32;
  }

  // TODO add a check for windows here, we can check to handle this
  const windowsChrome = false;
  if (!windowsChrome) {
    return 1;
  }

  // For windows chromium issues with scroll, it adjust scroll speed to keep consist
  // https://bugs.chromium.org/p/chromium/issues/detail?id=1001735
  // https://bugs.chromium.org/p/chromium/issues/detail?id=1207308
  return 1 / window.devicePixelRatio;
};

export const onMousewheel = (event: WheelEvent, timeScale: TimeScaleReturn) => {
  if (event.deltaX === 0 && event.deltaY === 0) {
    return null;
  }

  const scrollSpeedAdjustment = scrollWheelSpeedAdjustment(event);

  // TODO handle MouseWheel X scroll
  const deltaY = -((scrollSpeedAdjustment * event.deltaY) / 100);

  if (event.cancelable) {
    event.preventDefault();
  }

  if (deltaY !== 0) {
    const zoomScale = Math.sign(deltaY) * Math.min(1, Math.abs(deltaY));
    // TODO scroll based on mouse position
    // const scrollPosition = event.clientX - canvas.getBoundingClientRect().left;

    return timeScale.zoomTime(zoomScale);
  } else {
    return null;
  }
};
